import { PRODUCTS } from "../../mock";

export default function Products() {
  return (
    <section
      id="comunidad"
      className="reveal"
      style={{
        position: "relative",
        zIndex: 2,
        background: "var(--surface-light)",
        padding: "100px 28px",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="eyebrow" style={{ marginBottom: 24 }}>
          Productos & Comunidad
        </div>
        <h2
          className="font-display"
          style={{
            fontSize: "clamp(2rem, 4.6vw, 3.4rem)",
            fontWeight: 500,
            letterSpacing: "-0.02em",
            lineHeight: 1.05,
            margin: "0 0 48px",
            maxWidth: 700,
          }}
        >
          Construye con estas{" "}
          <em style={{ fontStyle: "italic", fontWeight: 400 }}>
            herramientas.
          </em>
        </h2>

        <div className="flex items-center justify-center gap-2 mb-8 bg-green-50 text-green-700 px-4 py-2 rounded-full text-sm font-medium mx-auto w-fit">
          <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Verified WhatsApp Tech Provider
          <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
          </svg>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: 16,
          }}
        >
          {PRODUCTS.map((p) => (
            <ProductCard key={p.name} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductCard({ product }) {
  return (
    <article
      className="product-card"
      style={{
        position: "relative",
        background: "rgba(255,255,255,0.45)",
        border: "1px solid var(--line)",
        borderRadius: 18,
        padding: "26px 26px 28px",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        overflow: "hidden",
        transition: "transform 0.28s ease, border-color 0.28s ease",
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 500,
          letterSpacing: "0.2em",
          textTransform: "uppercase",
          color: "var(--ink-dim)",
        }}
      >
        {product.tag}
      </div>
      <h3
        className="font-display"
        style={{
          fontSize: "1.25rem",
          fontWeight: 500,
          lineHeight: 1.18,
          letterSpacing: "-0.01em",
          margin: 0,
        }}
      >
        {product.name}
      </h3>
      <p
        style={{
          fontSize: 13,
          lineHeight: 1.6,
          color: "var(--ink-dim)",
          margin: 0,
          flex: 1,
        }}
      >
        {product.desc}
      </p>
      <div style={{ marginTop: 6 }}>
        <a
          href={product.href || "#contacto"}
          target={product.external ? "_blank" : undefined}
          rel={product.external ? "noreferrer" : undefined}
          onClick={
            product.external
              ? undefined
              : (e) => {
                  e.preventDefault();
                  document
                    .getElementById("contacto")
                    ?.scrollIntoView({ behavior: "smooth" });
                }
          }
          className="btn-primary"
          style={{ padding: "8px 18px", fontSize: 12 }}
        >
          {product.cta} →
        </a>
      </div>

      <span aria-hidden className="product-bar" />

      <style>{`
        .product-card:hover {
          transform: translateY(-3px);
          border-color: var(--line-strong) !important;
        }
        .product-bar {
          position: absolute;
          left: 0; right: 0; bottom: 0;
          height: 1px;
          background: var(--ink);
          transform: scaleX(0);
          transform-origin: left center;
          transition: transform 0.5s cubic-bezier(0.22,1,0.36,1);
        }
        .product-card:hover .product-bar {
          transform: scaleX(1);
        }
      `}</style>
    </article>
  );
}
